module.exports = __webpack_public_path__ + "static/media/slide5.6de5650e.jpg";